// extracted by mini-css-extract-plugin
export var actions = "_18-0";
export var actionsContainer = "_18-6";
export var border = "_18-1";
export var childFullHeight = "_18-d";
export var collapse = "_18-2";
export var content = "_18-8";
export var contentChild = "_18-c";
export var fullscreen = "_18-a";
export var headerContainer = "_18-3";
export var headerRow = "_18-5";
export var hidePadding = "_18-9";
export var noScrollX = "_18-e";
export var noScrollY = "_18-f";
export var optOutTopPadding = "_18-b";
export var pagePadding = "_18-7";
export var profile = "_18-g";
export var profileContainer = "_18-h";
export var profileImage = "_18-i";
export var profileMain = "_18-j";
export var profileSubtitle = "_18-l";
export var profileTitle = "_18-k";
export var tabsWrapper = "_18-4";
export var title = "_18-m";